import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearStoredUser } from '../utils/auth';

export const adminActionButtonClass =
  'shrink-0 px-5 py-1.5 rounded bg-[#eda448] text-gray-900 text-sm font-semibold hover:bg-[#d8932e] transition-colors';

/** Add actions inside manage panels (distinct from amber Logout). */
export const panelAddButtonClass =
  'shrink-0 px-4 py-1 rounded-lg bg-sky-800 text-white text-sm font-semibold hover:bg-sky-700 transition-colors shadow-sm shadow-sky-950/40';

export function LogoutButton({ className = '' }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearStoredUser();
    navigate('/login');
  };

  return (
    <button
      type="button"
      onClick={handleLogout}
      className={`${adminActionButtonClass} ${className}`}
    >
      Logout
    </button>
  );
}
